import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/deploy-logs.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-sandbox',
  templateUrl: './sandbox.component.html',
  styleUrls: ['./sandbox.component.scss']
})
export class SandboxComponent implements OnInit {
  sandboxScripts = [
    {name: 'Reseed', link: '/sandbox'},
    {name: 'Re deploy API Server', link: '/deploy-sandbox'},
    {name: 'Reload Seed from S3', link: '/reload-sandbox-seed'},
    {name: 'Update Seed on S3', link: '/update-sandbox-seed-s3'},
    {name: 'Get API Server branch name', link: '/get-sandbox-api-branch-name'},
    {name: 'Update API branch name', link: '/update-sandbox-api-branch'},
    {name: 'Update Internal WEB branch name', link: '/update-sandbox-internal-web-branch-name'},
    {name: 'Get WEB branch name', link: '/get-sandbox-web-branch-name'},
    {name: 'Update WEB branch name', link: '/update-sandbox-web-branch-name'},
    {name: 'Re deploy WEB', link: '/deploy-sandbox-web'},
    {name: 'Pause RDS Instance', link: '/pause-rds-sandbox'},
    {name: 'Resume RDS Instance', link: '/resume-rds-sandbox'},
    {name: 'Get RDS Status', link: '/rds_status_sandbox'},
    {name: 'Seed Customer Tasks', link: '/seed-sandbox-customer-tasks'},
    {name: 'Seed Business Tasks', link: '/seed-sandbox-business-tasks'},
    {name: 'Turn demo wall on', link: '/set-sandbox-demo-page-true'},
    {name: 'Turn demo wall off', link: '/set-sandbox-demo-page-false'},
    {name: 'Get Deploy Logs', link: '/get-sandbox-deploy-logs'},
    {name: 'Run Command on Sandbox', link: '/run-command-on-sandbox'},
    {name: 'View Pods', link: '/view-sandbox-pods'},
    {name: 'Change Language Filter to US', link: '/change-language-filter-us'},
    {name: 'Change Language Filter to CA', link: '/change-language-filter-ca'},
    {name: 'Get Web Build Logs', link: '/get-build-logs?name=bizzycar-sandbox-web-v2'},
  ];

  showResponseModal = false;
  currentEndpoint = '';
  currentScriptName = '';
  responseData: SafeHtml = '';
  isLoading = false;
  error = '';

  constructor(
    private apiService: ApiService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
  }

  executeScript(script: any) {
    this.currentEndpoint = script.link;
    this.currentScriptName = script.name;
    this.showResponseModal = true;
    this.isLoading = true;
    this.error = '';
    this.responseData = '';

    this.apiService.makeApiCall(this.currentEndpoint).subscribe({
      next: (response) => {
        this.responseData = this.sanitizer.bypassSecurityTrustHtml(response);
        this.isLoading = false;
      },
      error: (err) => {
        this.error = 'Failed to execute script. Please try logging out and back in. Check slack #aws-chatbot to confirm the script didnt run before retrying';
        this.isLoading = false;
      }
    });
  }

  closeResponseModal() {
    this.showResponseModal = false;
    this.currentEndpoint = '';
    this.currentScriptName = '';
    this.responseData = '';
    this.error = '';
  }

  copyResponse() {
    // Get the text content from the response div
    const responseElement = document.querySelector('.response-content div');
    if (responseElement) {
      const textToCopy = responseElement.textContent || '';
      if ((navigator as any).clipboard && window.isSecureContext) {
        (navigator as any).clipboard.writeText(textToCopy).then(() => {
          // Optional: Show a success message
          const copyButton = document.querySelector('.copy-button');
          if (copyButton) {
            const originalText = copyButton.innerHTML;
            copyButton.innerHTML = '<span class="copy-icon">✓</span> Copied!';
            setTimeout(() => {
              copyButton.innerHTML = originalText;
            }, 2000);
          }
        }).catch(err => {
          console.error('Failed to copy text: ', err);
        });
      } else {
        // Fallback for non-secure contexts
        const textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          const copyButton = document.querySelector('.copy-button');
          if (copyButton) {
            const originalText = copyButton.innerHTML;
            copyButton.innerHTML = '<span class="copy-icon">✓</span> Copied!';
            setTimeout(() => {
              copyButton.innerHTML = originalText;
            }, 2000);
          }
        } catch (err) {
          console.error('Failed to copy text: ', err);
        }
        textArea.remove();
      }
    }
  }

  updateAPIBranchName(name: string) {
    this.currentEndpoint = `/update-sandbox-api-branch?name=${name}`;
    this.currentScriptName = 'Update API Branch Name';
    this.executeScript({ link: this.currentEndpoint, name: this.currentScriptName });
  }

  updateWEBBranchName(name: string) {
    this.currentEndpoint = `/update-sandbox-web-branch-name?name=${name}`;
    this.currentScriptName = 'Update WEB Branch Name';
    this.executeScript({ link: this.currentEndpoint, name: this.currentScriptName });
  }

  updateInternalWEBBranchName(name: string) {
    this.currentEndpoint = `/update-sandbox-internal-web-branch-name?name=${name}`;
    this.currentScriptName = 'Update Internal WEB Branch Name';
    this.executeScript({ link: this.currentEndpoint, name: this.currentScriptName });
  }

  runCommand(command: string) {
    this.currentEndpoint = `/run-command-on-sandbox?name=${command}`;
    this.currentScriptName = 'Run Command';
    this.executeScript({ link: this.currentEndpoint, name: this.currentScriptName });
  }
}
